import { createRouter, createWebHistory } from "vue-router";



//import StartView from "./views/StartSpaceX.vue";
import StartView from "./views/StartView.vue";
import MenuView from "./views/MenuView.vue";
import CheckoutView from "./views/CheckoutView.vue";
import CompleteView from "./views/CompleteView.vue";
import ReceiptView from "./views/ReceiptView.vue";
import ErrorView from "./views/ErrorView.vue";
import NotFound from "./views/NotFound.vue";
import RegisterView from "./views/RegisterView.vue";
import AdminView from "./views/AdminView.vue";
import AdminLogin from "./views/admin/LoginView.vue";
import AdminMenu from "./views/admin/MenuView.vue";
import OAuthCallback from "./views/OAuthCallback.vue";


const routes = [
  { path: "/admin/oauth", component: OAuthCallback, name: "oauth" },
  { path: "/admin/login", component: AdminLogin, name: "admin-login" },
  { path: "/admin/dashboard", component: AdminView, name: "admin" },
  { path: "/admin/menu", component: AdminMenu, name: "admin-menu" },
  { path: "/admin/", redirect: () => { return { path: `/admin/login` }; }, },
  { path: "/kiosk/", redirect: () => { return { path: `/kiosk/start` }; }, },
  {
    path: "/kiosk/start",
    component: StartView,
    name: "start",
    props: (route) => ({ orderTypeRef: route.query.orderTypeRef })
  },
  { path: "/kiosk/register", component: RegisterView, name: "register" },
  { path: "/kiosk/menu", component: MenuView, name: "menu" },
  { path: "/kiosk/checkout", component: CheckoutView, name: "checkout" },
  { path: "/kiosk/complete", component: CompleteView, name: "complete" },
  { path: "/kiosk/error", component: ErrorView, name: "error", props: true },
  {
    path: '/receipt/:ref',
    name: 'receipt',
    component: ReceiptView
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: NotFound,
  },

];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});


router.beforeEach((to, from, next) => {
  if (to.path === from.path) {
    console.error("Detected loop in kiosk start, stopping further redirects");
    next(false); // Stop routing if it tries to go to the same route
    return;
  }
  next();
});

export default router;
